import React, { Component } from 'react';
import { Form, Label, Dropdown } from 'semantic-ui-react';

// import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import autobind from 'react-autobind';

class renderDropboxCasemanagers extends Component {
  constructor (props) {
    super(props);
    autobind(this);
  }

  componentDidMount () {
    // select treatment when page loads if theres one on parent's state
    if (this.props.signUpTreatment) {
      this.props.input.onChange(this.props.signUpTreatment);
      this.props.input.onBlur();
    }
  }

  updateEnvironment (value) {
    let environmentString = '';

    switch (value) {
      case 'f429786d-dfd2-4ca6-8499-075ad2afdcf2':
        environmentString = 'ninlaro';
        break;
      case '9a112184-84ba-4e97-8823-c2ab1a11e59c':
        environmentString = 'alunbrig';
        break;
      case 'e10d1932-10da-4967-a70f-42ba1e2c1b7c':
        environmentString = 'iclusig';
        break;
      case '5727dfcf-3786-42de-a82c-a7ab5e34274d':
        environmentString = 'fruzaqla';
        break;
      case '3a40fa97-a4c1-4b74-a6a3-7fb00cce61d5':
        environmentString = 'mimrylo';
        break;
      default:
        environmentString = '';
        break;
    }

    this.props.updateSignTreatment(value);

    // update url / re-render page
    if (!this.props.location.pathname.includes(environmentString)) {
      this.props.history.push(`/casemanagers/${environmentString}/hps/enroll/eligibility`);
    }
  }

  render () {
    const showError = this.props.errorMessage && this.props.meta.touched && this.props.meta.error;
    return (
      <Form.Field className={ `${this.props.customClass || ''} ${showError ? 'error' : ''} ${this.props.required ? 'required' : ''}` }>
        <label>{ this.props.label }</label>
        <Dropdown
          { ...this.props.input }
          selection
          compact
          search
          selectOnBlur={ false }
          value={ this.props.input.value }
          onChange={ (param, data) => {
            this.props.input.onChange(data.value);
            this.props.input.onBlur();
            this.updateEnvironment(data.value);
          } }
          options={ this.props.options }
          onClick={ this.props.onClick || function () {} }
        />
        {showError && <Label basic pointing>{ this.props.errorMessage }</Label> }
      </Form.Field>
    );
  }
}

export default withRouter(renderDropboxCasemanagers);
